import React from "react";

export default function ArchiveList({ items, onItemClick, isLoading }) {
  if (isLoading) {
    return (
      <div className="archive-list-loading">
        <p>Cargando resultados...</p>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <div className="archive-list-empty">
        <p>No se encontraron resultados. Intenta con otros criterios de búsqueda.</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-CO", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatProvenance = (provenance) => {
    if (!provenance) return null;
    if (provenance.name) return provenance.name;
    return "Procedencia no confirmada";
  };

  return (
    <div className="archive-list">
      <div className="archive-grid">
        {items.map((item) => (
          <button
            key={item.id}
            className={`archive-item archive-item--${item.type}`}
            onClick={() => onItemClick(item)}
            type="button"
          >
            <div className="archive-item__thumbnail">
              {item.type === "image" && item.thumbnail ? (
                <img
                  src={item.thumbnail}
                  alt={item.title || "Sin título"}
                  loading="lazy"
                />
              ) : (
                <div className="archive-item__placeholder">
                  {item.type === "image" ? (
                    <span className="icon">🖼️</span>
                  ) : (
                    <span className="icon">📄</span>
                  )}
                </div>
              )}
              <div className="archive-item__type-badge">
                {item.type === "image" ? "Imagen" : "Historia"}
              </div>
            </div>
            <div className="archive-item__content">
              <h3 className="archive-item__title">
                {item.title || "Sin título"}
              </h3>
              <p className="archive-item__summary">
                {item.summary
                  ? item.summary.substring(0, 100) + (item.summary.length > 100 ? "..." : "")
                  : "Sin descripción"}
              </p>
              <div className="archive-item__meta">
                <span className="archive-item__date">
                  Subida: {formatDate(item.uploadDate || item.sentDate)}
                </span>
                {item.captureDate && (
                  <span className="archive-item__date">Captura: {formatDate(item.captureDate)}</span>
                )}
                {item.provenance && (
                  <span className={`archive-item__provenance${item.provenance.warning ? " archive-item__provenance--warning" : ""}`}>
                    Fuente: {formatProvenance(item.provenance)}
                  </span>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
